import { defineMessages } from 'react-intl';

export default defineMessages({
    searchResults: {
        id: 'e1p.gateway.views.search.Search Results',
        defaultMessage: 'Search Results',
    },
    searching: {
        id: 'e1p.gateway.views.search.Searching...',
        defaultMessage: 'Searching...',
    },
    noResultsFoundFor: {
        id: 'e1p.gateway.views.search.No results found for',
        defaultMessage: 'No results found for "{query}". Note: You can only search on valid policy and quote numbers.',
    },
    accountResults: {
        id: 'e1p.gateway.views.search.Account Results',
        defaultMessage: 'Accounts ({accountResultsNumber})',
    },
    policyResults: {
        id: 'e1p.gateway.views.search.Policy Results',
        defaultMessage: 'Policies ({policyResultsNumber})',
    },
    jobResults: {
        id: 'e1p.gateway.views.search.Job Results',
        defaultMessage: 'Quotes ({jobResultsNumber})',
    }
});
